
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../components/theme/text/Text";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import { getShipmentStatusLabeldata } from "../../../../utils/labelColorText";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../utils/permissions';
import { useSelector } from "react-redux";
import { SHIPMENTS_FILTER_KEYS } from "../../../../components/global/DataGrid/Filter";
import { useGetShipmentsQuery } from "../../../../newapi/order/shipmentsSlice";
import SHQuickAction from "../../../../components/theme/Modal/SHQuickAction";
import { RELATION_ORDERS_DEFAULT } from "../../../../components/theme/datagrid3/groupingPresets/GroupingPresets";
import ShDataGrid3 from "../../../../components/theme/datagrid3/ShDataGrid3";
import { RELATION_ORDERS_SHIPMENTS } from "../family";
import { getTrackingLink } from "../../../../utils/shipping";

const SpOrderDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));
const SpReturnDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpReturnDetails/SpReturnDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <ButtonGroup version={2}>
            {/* {props.hasModifyPrivilege && (
            )} */}
        </ButtonGroup>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [SHIPMENTS_FILTER_KEYS.SHIPPER, SHIPMENTS_FILTER_KEYS.TYPE, SHIPMENTS_FILTER_KEYS.SHIPMENT_STATUS],
};

const OutboundShipments = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();
    const [returnIsExtended, setReturnIsExtended] = useState(false);
    const [returnSpLoading, setReturnSpLoading] = useState();

    
    const [config, setConfig] = useState();

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.OUTBOUND_MANAGE])
    );

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);
        

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params?.row?.order) return;
    
        const newOrderId = parseInt(params.row.order.id);
        // Only update state if the productId has actually changed
        if (orderIdRef.current !== newOrderId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const [returnId, setReturnId] = useState();
    const returnIdRef = useRef(orderId);
    
    const getReturnDetails = (params) => {
        if (!params?.row?.return) return;
    
        const newReturnId = parseInt(params.row.return.id);
        // Only update state if the productId has actually changed
        if (returnIdRef.current !== newReturnId) {
            if(!spLoading) {
                setReturnSpLoading(true);
            }
            setReturnId(newReturnId);
            returnIdRef.current = newReturnId; // Update the ref to the new value
        }
        setReturnIsExtended(true);
    };

    const columns = [
        {
            field: "trackingNumber",
            headerName: t("tracking_number"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                const trackingUrl = getTrackingLink(params.row);

                if (!trackingUrl) {
                    return params.row.trackingNumber;
                }

                return (
                <Box sx={{height:1,display:"flex",flexDirection:"column",justifyContent:"center"}} onClick={() => {window.open(trackingUrl, "_blank")}}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.trackingNumber}</Text>
                </Box>);
            }
        },
        {field: "type", headerName: t("type"),flex:1, sortable: false,
            renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            const handleClick = (event) => {
                let type = "";
                if (params.row.order && !params.row.return) {
                    type = "order";
                } else if (params.row.return) {
                    type = "return";
                }

                event.stopPropagation(); // Prevent click from propagating to the row
                if (type === "order") {
                    getOrderDetails(params);
                } else if (type === "return") {
                    getReturnDetails(params);
                }
            };

            let description = "";
            if (params.row.order && !params.row.return) {
                description = `${t("order")} - ${params.row.order.webshopreference}`;
            } else if (params.row.return) {
                description = `${t("return")} - ${params.row.return.reference}`;
            }

            return (
                <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{description}</Text>
                </Box>
            );
        }},
        {field: "name", headerName: t("name"),flex:1, sortable: false,
            renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let name = "";
            if (params.row.order) {
                name = params.row.order.deliveryName;
            } else if (params.row.return) {
                name = params.row.return.name;
            }

            return name;
        }},
        {
            field: "address",
            headerName: t("address"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return `${params.row.street} ${params.row.house_nr}${params.row.house_nr_extra}`;
            }
        },
        {
            field: "city",
            headerName: t("city"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return params.row.city;
            }
        },
        {
            field: "postal",
            headerName: t("postal"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return params.row.postal;
            }
        },
        {
            field: "country",
            headerName: t("country"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return params.row.country?.toUpperCase();
            }
        },
        {
            field: "shipper",
            headerName: t("shipper"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.shipper.type === "cirro") {
                    return params.row.externalShipperName;
                }
                
                return `${params.row.shipper?.name} - ${params.row.shipperProfile?.name}`;
            },
            grouping: RELATION_ORDERS_DEFAULT.SHIPPER,
        },
        {
            field: "shipmentStatus", 
            headerName: t("shipment_status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                if (!params.row.shipmentStatus) {
                    return "";
                }

                const stateData = getShipmentStatusLabeldata(params.row.shipmentStatus, theme);
                let labelcolor = stateData.labelcolor;
                let labeltext = stateData.labeltext;

                // If there are shipper events, wrap the label with SHQuickAction
                if (params.row.shipperEvents && params.row.shipperEvents.length > 0) {
                    return (
                        <SHQuickAction
                            maxWidth={700}
                            component={
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        pt: 2,
                                        px: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 2,
                                        }}
                                    >
                                        <Text
                                            bold
                                            sx={{ width: "140px", flexShrink: 0 }}
                                        >
                                            {t("date")}
                                        </Text>
                                        <Text
                                            bold
                                            sx={{ width: "140px", flexShrink: 0 }}
                                        >
                                            {t("type")}
                                        </Text>
                                        <Text
                                            bold
                                            sx={{ minWidth: "350px", flexShrink: 0 }}
                                        >
                                            {t("status")}
                                        </Text>
                                    </Box>

                                    {params.row.shipperEvents.map((event, index) => (
                                        <Box
                                            key={index + "event"}
                                            sx={{
                                                position: "relative",
                                                minHeight: 40,
                                                py: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                            }}
                                        >
                                            <Text sx={{ width: "140px", flexShrink: 0 }}>
                                                {event.timeStamp ? new Date(event.timeStamp).toLocaleString(i18n.language) : "-"}
                                            </Text>
                                            <Text sx={{ width: "140px", flexShrink: 0 }}>
                                                {event.type}
                                            </Text>
                                            <Text sx={{ minWidth: "350px", flexShrink: 0 }}>
                                                {event.status}
                                            </Text>
                                        </Box>
                                    ))}
                                </Box>
                            }
                        >
                            {({anchorEl, onMouseEnter, onMouseLeave, onTouchStart}) => (
                                <Box
                                    aria-owns={anchorEl ? "simple-popover" : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={onMouseEnter}
                                    onMouseLeave={onMouseLeave}
                                    onTouchStart={onTouchStart}
                                    sx={{
                                        display: "inline-flex",
                                    }}
                                >
                                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                                        {t(labeltext)}
                                    </ShLabel>
                                </Box>
                            )}
                        </SHQuickAction>
                    );
                }
                
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "shipmentDate", 
            headerName: t("shipment_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = params.row.shipmentDate && params.row.shipmentDate !== null ? new Date(params.row.shipmentDate) : undefined;
              
                return (
                    <Text>
                        {date ? date.toLocaleDateString(i18n.language) : "-"}
                    </Text>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                // WarehouseInvoiceCard
                // return (
                //     // <WarehouseInvoiceCard
                //     //     onClick={() => getInvoice(params)}
                //     //     skeleton={params.row.skeleton}
                //     //     {...params.row}
                //     // />
                //     // <ShTextSkeleton/>
                // )
            }
        },
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid3
                gridKey={RELATION_ORDERS_SHIPMENTS.SHIPMENTS.gridKey}
                enableGrouping={true}
                key={theme.palette.mode}
                content={useGetShipmentsQuery}
                config={config}
                gridActions={<GridActions></GridActions>} 
                title={t('all')}
                gridOptions={gridOptions} 
                sortModel={{field: columns[10].field,type:"DESC"}}
                columns={columns}
                rows={data}
                >
            </ShDataGrid3>

            {spLoading && 
                <SpOrderDetails
                    orderId={orderId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                /> 
            }
            {returnSpLoading && 
                <SpReturnDetails
                    returnId={returnId}
                    isExtended={returnIsExtended}
                    setIsExtended={setReturnIsExtended}
                    // data={pickingJobData}
                /> 
            }
        </Box>
    );
}

export default OutboundShipments;